const data = {
  email: 'milesdrobson@gmail.com',
  linkedin: 'https://www.linkedin.com/in/miles-robson-b4124a33/',
  twitter: 'https://twitter.com/confirm4crit',
  github: 'https://github.com/confirm4crit',
 
}

export default data
